export const EISPackage = {
  essentials: 'Essentials',
  standard: 'Standard',
  premium: 'Premium',
};

export const StandardTabInfo = {
  tab1: 'Vegetation Management',
  tab2: 'Outage Prediction',
  tab3: 'Crop Health',
};

export const Tiles = {
  tile1: 'essentials',
  tile2: 'standard',
  tile3: 'premium',
};

export const metaData = {
  text1: 'Weather API',
  text2: 'History on Demand (HoD) API',
  text3: 'Standard Edition',
  text4: 'Vegetation Management, Outage Prediction',
  text5: 'Agriculture / Crop Health',
  text6: 'Crop Health',
  text7: 'Geiger-mode LiDAR',
  text8: 'Renewables Energy Forecasting',
  text9: '(Premium Edition)',
};
